import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';

import EntryModal, {
  Entry as BookEntryModalEntry,
} from '../../../../BookEntries/components/Modal';
type BankReconciliationDialogsProps = {
  entryDialogLoading: boolean;
  entryDialogOpen: boolean;
  entryDialogEntry: BookEntryModalEntry | null;
  observationDialogOpen: boolean;
  observationDraft: string;
  maxObservationLength: number;
  onCloseEntryDialog: () => void;
  onCloseObservationDialog: () => void;
  onSaveObservationDialog: () => void;
  onObservationDraftChange: (value: string) => void;
};

const BankReconciliationDialogs: React.FC<BankReconciliationDialogsProps> = ({
  entryDialogLoading,
  entryDialogOpen,
  entryDialogEntry,
  observationDialogOpen,
  observationDraft,
  maxObservationLength,
  onCloseEntryDialog,
  onCloseObservationDialog,
  onSaveObservationDialog,
  onObservationDraftChange,
}) => (
  <>
    <Dialog open={entryDialogLoading} maxWidth="sm" fullWidth>
      <DialogContent sx={{ py: 6, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </DialogContent>
    </Dialog>

    {entryDialogOpen && (
      <EntryModal
        entry={entryDialogEntry ?? undefined}
        open={entryDialogOpen}
        onClose={onCloseEntryDialog}
        readOnly
        allowSaving={false}
      />
    )}

    <Dialog
      open={observationDialogOpen}
      onClose={onCloseObservationDialog}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Observación</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          fullWidth
          multiline
          minRows={4}
          maxRows={12}
          placeholder="Ingresa una observación"
          value={observationDraft}
          inputProps={{ maxLength: maxObservationLength }}
          onChange={(event) => onObservationDraftChange(event.target.value)}
        />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 0.5 }}
        >
          {`${observationDraft.length}/${maxObservationLength}`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseObservationDialog}>Cancelar</Button>
        <Button variant="contained" onClick={onSaveObservationDialog}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  </>
);

export default BankReconciliationDialogs;
